<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <article class="title-section form-section">
            <p class="page-title text-center">
            <img
              src="../../../public/assets/images/logo.png"
              alt="background image"
            >
            </p>
            <h1 class="page-extra-page-title text-center">Apply in Standard Program</h1>

          </article>
          <article class="d-flex flex-column align-items-center px-4 pb-5 form-section">
            <p class="text-left" style="max-width: 795px; margin-bottom: 34px;">
              Based on one or more of your answers, you are not eligible for coverage on this application, please apply coverage using our Standard Application:            </p>
            <div class="d-flex" style="max-width: 651px;">
              <div class="d-flex flex-column">

                <button type="submit" class="next-btn-extra mont spaced pull-right" :disabled="!state.pageOneIsValid && !state.pageTwoIsValid"
                        :class="{submitDisabled: !state.pageOneIsValid && !state.pageTwoIsValid }" @click="navigateToNext('standard-application-1')" style="text-align: center">
                  Apply in Standard Program </button>

              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import { STATES } from "../../utils/constants";
var moment = require('moment')

export default {
  name: "individual-appraiser-1",
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    individualAppraiser() {
      return this.$store.state.rxApplication.rxApplication;
    },
    state() {
      return this.$store.state.rxApplication;
    },
    errorMsg() {
      return this.$store.state.rxApplication.errorMsg;
    }
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Individual-Appraiser-Application.pdf') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadWithVueResource() {

      this.$http({
        method: 'get',
        url: 'https://orep.org/wp-content/uploads/2019/09/IL_NH_MT-Individual-Appraiser-Application.pdf',
        responseType: 'arraybuffer'
      })
        .then(response => {
          this.forceFileDownload(response)
        })
        .catch(() => console.log('error occured'))

    },
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    navigateToNextCustomLink() {
      window.location("https://orep.org/wp-content/uploads/2019/09/IL_NH_MT-Individual-Appraiser-Application.pdf", "_self");
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.rxApplication.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },

  components: {
    Datepicker
  }
};
</script>

<style scoped>
  .page-desc {
    width: 295px;
    height: 45px;
  }
  .form-title {
    font-size: 35px !important;
  }
  .w-40 {
    flex: 0 0 40px;
  }
</style>
